module.exports = __webpack_public_path__ + "static/img/10.0c44d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/10.jpg
// module id = 6/0P
// module chunks = 1